<template>
  <a-modal
      v-bind:open="computedShowModal"
      title="결제 카드 등록"
      width="600px"
      :closable="true"
      :footer="null"
      :mask-closable="true"
      :mask-style="{backdropFilter: 'blur(2px)'}"
      :keyboard="false"
      :destroyOnClose="true"
      @cancel="uiHandler.closeModal"
      class="add-card-modal"
      centered
  >
    <div class="modal-content-body">
      <a-col class="input-area">
        <a-row>
          <h4 class="input-title">
            카드번호
          </h4>
        </a-row>
        <a-row class="input-content card-number">
          <a-input
              class="pw-placeholder"
              type="text"
              ref="firstInput"
              placeholder="●●●●-●●●●-●●●●-●●●●"
              :maxlength="19"
              v-model:value="cardInfo.cardNumber.first"
              @change="uiHandler.formatCardNo($event, 'cardNumber', 'first', 'second')"
          />
        </a-row>
        <a-row>
          <div class="card-description">
            국내 신용카드 번호 16자리(또는 15자리)를 입력해주세요.
          </div>
        </a-row>
      </a-col>
      <a-col class="input-area">
        <a-row>
          <h4 class="input-title">
            유효기간
          </h4>
        </a-row>
        <a-row class="input-content expiration-date">
          <a-input
              type="text"
              placeholder="MM"
              :maxlength="2"
              ref="mmInput"
              v-model:value="cardInfo.expiration.mm"
              @change="uiHandler.allowNumberOnly($event, 'expiration', 'mm', 'yy')"
          />
          <a-input
              type="text"
              placeholder="YY"
              :maxlength="2"
              ref="yyInput"
              v-model:value="cardInfo.expiration.yy"
              @change="uiHandler.allowNumberOnly($event, 'expiration', 'yy', 'pw')"
          />
        </a-row>
      </a-col>
      <a-col class="input-area">
        <a-row>
          <h4 class="input-title">
            생년월일 6자리
          </h4>
        </a-row>
        <a-row class="input-content birthday">
          <a-input
              type="text"
              placeholder="230131"
              :maxlength="12"
              ref="birthInput"
              v-model:value="cardInfo.birthday"
              @change="uiHandler.handleBusinessNumberInput"
          />
        </a-row>
        <a-row>
          <div class="card-description">
            법인카드의 경우 사업등록번호 10자리를 입력해주세요
          </div>
        </a-row>
      </a-col>

    </div>
    <div class="modal-content-footer">
      <div class="left">

      </div>
      <div class="btn-area">
        <button
            class="cancel-btn"
            @click="uiHandler.closeModal"
        >
          취소
        </button>
        <button
            class="ok-btn"
            ref="submitInput"
            @click="uiHandler.addCard"
        >
          등록
        </button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { jwtDecoder, businessNumberFormatter, phoneNumberFormatter, oneBtnDialog } from '@/utils/utils';
import PageHeader from '@/views/components/PageHeader.vue';
import dayjs from 'dayjs';

export default {
  name: 'AddCardModal',
  components: {
    PageHeader,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    computedShowModal() {
      return this.showModal;
    },
  },
  emits: ['closeModal', 'getCardList'],
  data() {
    return {
      cardInfo: {
        cardNumber: {
          first: '',
          second: '',
          third: '',
          fourth: '',
        },
        expiration: {
          mm: '',
          yy: '',
        },
        password: '',
        birthday: '',
      },
      uiHandler: this.ui(),
      apiHandler: this.api(),
    };
  },
  watch: {
    computedShowModal(newValue) {
      this.$nextTick(() => {
      })
    }
  },
  async mounted() {
  },
  methods: {
    phoneNumberFormatter,
    businessNumberFormatter,
    ui() {
      return {
        allowNumberOnly: (event, bigCategory, smallCategory, nextInputRefName) => {
          const numericValue = event.target.value.replace(/\D/g, '');
          event.target.value = numericValue;

          if(!smallCategory) {
            this.cardInfo[bigCategory] = numericValue;
          } else {
            this.cardInfo[bigCategory][smallCategory] = numericValue;
          }
        },
        handleBusinessNumberInput: (event) => {
          this.uiHandler.allowNumberOnly(event, 'birthday', null, 'submit');
          const formatBusinessNumber = (value) => {
            if (value.length > 10) {
              return value.slice(0, 10);
            } else {
              if (value.length > 6) {
                return `${value.slice(0, 3)}-${value.slice(3, 5)}-${value.slice(5, 10)}`;
              } else {
                return value
              }
            }
          };
          this.cardInfo.birthday = formatBusinessNumber(this.cardInfo.birthday);
        },
        formatCardNo: (event, bigCategory, smallCategory, nextInputRefName) => {
          let numericValue = event.target.value.replace(/\D/g, '');
          let formattedValue = '';

          // Check for credit card number
          if (numericValue.startsWith('34') || numericValue.startsWith('37')) {
            if (numericValue.length > 15) {
              numericValue = numericValue.slice(0, 15);
            }
            formattedValue = `${numericValue.slice(0, 4)}`;
            if (numericValue.length > 4) {
              formattedValue += `-${numericValue.slice(4, 10)}`;
            }
            if (numericValue.length > 10) {
              formattedValue += `-${numericValue.slice(10, 15)}`;
            }
          } else {
            if (numericValue.length > 16) {
              numericValue = numericValue.slice(0, 16);
            }
            for (let i = 0; i < numericValue.length; i += 4) {
              if (i > 0) {
                formattedValue += '-';
              }
              formattedValue += numericValue.slice(i, i + 4);
            }
          }

          event.target.value = formattedValue;

          if (!smallCategory) {
            this.cardInfo[bigCategory] = formattedValue;
          } else {
            this.cardInfo[bigCategory][smallCategory] = formattedValue;
          }
        },
        closeModal: () => {
          this.$emit('closeModal');
        },
        emitCardAdded: () => {
          this.$emit('card-added');
        },
        addCard: async () => {
          if(! await this.uiHandler.validateData()) return;

          const fullCardNumber = `${this.cardInfo.cardNumber.first}`;
          const params = {
            cardNo: fullCardNumber,
            expirationYy: this.cardInfo.expiration.yy,
            expirationMm: this.cardInfo.expiration.mm,
            identificationNo: this.cardInfo.birthday,
          }
          const response = await this.apiHandler.addCard(
              params,
              async (response) => {
                await oneBtnDialog('카드 등록 완료', '카드 등록이 완료되었습니다.', false);
                this.uiHandler.initCardData();
                await this.uiHandler.emitCardAdded();
                this.uiHandler.closeModal();
              },
              async (error) => {
                console.log(error);
                this.uiHandler.initCardData();
                await oneBtnDialog('카드 등록 실패', error.response.data.message, false);
              }
          )
        },
        initCardData: () => {
          this.cardInfo = {
            cardNumber: {
              first: '',
              second: '',
              third: '',
              fourth: '',
            },
            expiration: {
              mm: '',
              yy: '',
            },
            password: '',
            birthday: '',
          }
        },
        validateData: async () => {
          if (!this.cardInfo.cardNumber.first) {
            await oneBtnDialog('카드 번호 미기입', '카드 번호를 입력해 주세요.', false);
            return false;
          }

          const fullCardNumber = `${this.cardInfo.cardNumber.first}${this.cardInfo.cardNumber.second}${this.cardInfo.cardNumber.third}${this.cardInfo.cardNumber.fourth}`;
          if (isNaN(parseInt(fullCardNumber))) {
            await oneBtnDialog('카드 번호 오류', '카드 번호가 올바르지 않습니다.', false);
            return false;
          }

          const { mm, yy } = this.cardInfo.expiration;
          if (!mm || !yy) {
            await oneBtnDialog('만료일 미기입', '카드 만료일을 입력해 주세요.', false);
            return false;
          }

          if (mm.length !== 2 || yy.length !== 2) {
            await oneBtnDialog('만료일 오류', '카드 만료일이 올바르지 않습니다.', false);
            return false;
          }

          const currentYear = dayjs().year(); // Get the current year with dayjs
          const currentMonth = dayjs().month() + 1; // Get the current month with dayjs

          const inputYear = parseInt(`20${yy}`, 10);
          const inputMonth = parseInt(mm, 10);

          // 현재 날짜와 비교
          if (inputYear < currentYear || (inputYear === currentYear && inputMonth < currentMonth)) {
            await oneBtnDialog('만료일 오류', '카드 만료일이 과거입니다. 올바른 만료일을 입력해 주세요.', false);
            return false;
          }

          if (!this.cardInfo.birthday) {
            await oneBtnDialog('생년월일 미입력', '생년월일 6자리를 입력해 주세요.', false);
            return false;
          }

          return true;
        }
      }
    },
    api() {
      return {
        addCard: async (param, success, fail) => {
          this.$store.commit('setIsLoading', true);
          try {
            const response = await this.$apiInstance.post(`/subscriptions/add/card/${sessionStorage.getItem("selectedSubscriptionId")}`, param);
            if(response.status !== 200 && response.status !== 201) {
              throw Error('서버에서 응답을 받지 못헀습니다.');
            }
            success(response);
          } catch(error) {
            fail(error);
          } finally {
            this.$store.commit('setIsLoading', false);
          }
        }
      }
    },

  },
};
</script>
<style lang="scss" scoped>
.add-card-modal {
  .modal-content-body {
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 20px;
    gap: 16px;

    .input-area {

      .input-title {
        font-size: 16px;
        color: #2F3337;
        font-weight: bolder;
      }
      .input-content {
        display: flex;
        gap: 8px;
        input {
          &::placeholder {
            font-size: 14px;
          }
        }

        .pw-placeholder {
          &::placeholder {
            font-size: 10px;
          }
        }
      }

      .input-content.card-number {
        width: 260px;

        input {
          flex: 1;
        }
      }
      .input-content.expiration-date {

        input {
          width: 80px;
        }
      }
      .input-content.password {
        width: 100%;
        input {

        }
      }
      .input-content.birthday {
        input {

        }
      }
    }

    .card-description {
      font-size: 12px;
      color: #8D939A;
      margin: 5px 0 0 5px;
    }
  }

  .modal-content-footer {
    display: flex;
    justify-content: space-between;
    padding: 0 20px 20px 20px;
    .btn-area {
      display: flex;
      gap: 8px;
      button {
        padding: 0 18px;
      }

      .ok-btn {
        border-radius: 6px;
        font-weight: bolder;
        background-color: #ffe414;
      }

      .cancel-btn {
        border-radius: 6px;
      }
    }
  }
}
</style>